import { Module } from 'vuex';

import { ConfigState } from '../../models';

import { ClearModuleAction } from '../../store/config/actions/clear-module.action';
import { LoadInstancesAction } from '../../store/config/actions/load-instances.action';
import { CONFIG_CONSTS } from '../../store/config/config.consts';
import { CurrentInstanceGetter } from '../../store/config/getters/current-instance.getter';
import { InstancesGetter } from '../../store/config/getters/instances.getter';
import { KpisGetter } from '../../store/config/getters/kpis.getter';
import { ClearModuleMutation } from '../../store/config/mutations/clear-module.mutation';
import { SetInstancesMutation } from '../../store/config/mutations/set-instances.mutation';

export const CONFIG_MODULE: Module<ConfigState, any> = {
  namespaced: true,

  state: (): ConfigState => {
    return {
      instances: []
    };
  },

  getters: {
    [CONFIG_CONSTS.getters.instances]: InstancesGetter.execute,
    [CONFIG_CONSTS.getters.currentInstance]: CurrentInstanceGetter.execute,
    [CONFIG_CONSTS.getters.kpis]: KpisGetter.execute
  },

  actions: {
    [CONFIG_CONSTS.actions.loadInstances]: LoadInstancesAction.execute,

    [CONFIG_CONSTS.actions.clearModule]: ClearModuleAction.execute
  },

  mutations: {
    [CONFIG_CONSTS.mutations.setInstances]: SetInstancesMutation.execute,

    [CONFIG_CONSTS.mutations.clearModule]: ClearModuleMutation.execute
  }

};
